import React from 'react';
import {Avatar} from 'antd';
import {getUrl} from '../../util/image';

export default class Index extends React.Component {
    getColor = (name)=>{
        var str ='';
        for(var i=0; i<name.length; i++) {
            str += parseInt(name[i].charCodeAt(0), 10).toString(16);
        }
        return '#' + str.substr(-3);
    }

    render() {
        let {style, nickname = '', photo, size = 'large', shape = 'circle'} = this.props;

        const styles = Object.assign({ marginRight:10, backgroundColor: this.getColor(nickname), verticalAlign: 'middle' }, style);

        return <Avatar alt={nickname.substr(-2)} src={photo ? getUrl(photo, 'avatar_150') : undefined} style={styles} size={size} shape={shape}>
            {photo ? "" : nickname.substr(-2)}
        </Avatar>
    }
}



// WEBPACK FOOTER //
// ./src/components/Common/UserPhoto.js